module.exports = "/packs/period2-675c39489c5ec84a766ec35ccdbf62a5.png";